module.exports = __webpack_public_path__ + "media/auto_history/men-f89ebb18.png";